import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope) => {
    /**
     * Homeowners line of business specific values to be made available on the fnol object
     */

    const ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope'];

export default fn;